import React from "react";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import { Avatar, AvatarGroup, Stack, Tooltip } from "@mui/material";
import { BookmarkVisibility, IBookmarkSharedUser } from "store/types";

import { getInitials } from "./bookmark-page";

interface Props {
  visibility: BookmarkVisibility | undefined;
  sharedUsers?: IBookmarkSharedUser[];
}

const TITLE: Record<BookmarkVisibility, string> = {
  private: "Private to you. No one else can see this view.",
  shared: "Shared with specific teammates.",
  account: "Shared with everyone on your team."
};

const ICON: Record<BookmarkVisibility, typeof LockOutlinedIcon> = {
  private: LockOutlinedIcon,
  shared: PeopleAltOutlinedIcon,
  account: PublicOutlinedIcon
};

export const ShareIcon: React.FC<Props> = ({ visibility, sharedUsers }) => {
  const resolved: BookmarkVisibility = visibility ?? "private";
  const hasAvatars = resolved === "shared" && !!sharedUsers && Boolean(sharedUsers.length);

  const title = hasAvatars ? `Shared with ${sharedUsers!.map((u) => u.full_name).join(", ")}` : TITLE[resolved];
  const Icon = ICON[resolved];

  return (
    <Tooltip title={title} placement="left" arrow enterDelay={400}>
      {hasAvatars ? (
        <AvatarGroup
          max={3}
          sx={{
            "& .MuiAvatar-root": {
              width: 20,
              height: 20,
              fontSize: 9,
              border: "1px solid #fff"
            }
          }}
        >
          {sharedUsers!.map((user) => (
            <Avatar key={user.id} src={user.profile_photo_url || undefined} alt={user.full_name}>
              {getInitials(user.full_name)}
            </Avatar>
          ))}
        </AvatarGroup>
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ width: "24px", height: "24px", color: "text.secondary" }}
        >
          <Icon sx={{ fontSize: "14px" }} />
        </Stack>
      )}
    </Tooltip>
  );
};
